import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import './TripNotFound.css';

export default function TripNotFound() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="trip-error-view">
            <div className="error-glass-container">
                <div className="error-content">
                    <div className="error-badge">404</div>
                    <h1>{t('trip.not_found_title')}</h1>
                    <p>
                        {t('trip.not_found_text')}
                    </p>

                    <div className="error-actions">
                        <button className="error-primary-btn" onClick={() => navigate({ to: '/' })}>
                            <span className="btn-icon">✨</span>
                            {t('trip.plan_new')}
                        </button>
                    </div>

                    <div className="error-suggestions">
                        <span>{t('trip.popular_starting')}:</span>
                        <div className="suggestion-chips">
                            <button onClick={() => navigate({ to: '/' })} className="chip">Paris</button>
                            <button onClick={() => navigate({ to: '/' })} className="chip">Tokyo</button>
                            <button onClick={() => navigate({ to: '/' })} className="chip">New York</button>
                            <button onClick={() => navigate({ to: '/' })} className="chip">Dubai</button>
                        </div>
                    </div>
                </div>
                <div className="error-decoration">
                    <div className="blob blob-1"></div>
                    <div className="blob blob-2"></div>
                </div>
            </div>
        </div>
    );
}
